import { BaseDevice, CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/mu68/list_icon.png'
// import en_list_icon from "@/assets/img/device/mu68/en_list_icon.png"
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { generateArray } from '@/tool/utility'
import { mu68VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST } from '../../light/light_effect_list'

export class Mu68 extends BaseDevice {
  magneticAxis: boolean = true
  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)

  minDelayTimer: number = 1
  maxDelayTimer: number = 60000

  name: string = 'MU68'
  icon: string = list_icon
  width: number = 666

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST

  y_number: number = 0
  square = getDeviceKeySquare(DevicePid.IYXMu68)
  inoperableKeys: KK[] = [0x50b]
  fnDisableKeys: KK[] = [
    0x0100, 0x0101, 0x0102, 0x0103, 0x0104, 0x0105, 0x0106, 0x0107, 0x0108, 0x0109, 0x010a, 0x010b, 0x010c, 0x0110, 0x020a, 0x020b, 0x020c, 0x0210, 0x0302, 0x0303, 0x030b, 0x030c, 0x0310, 0x040f, 0x0501, 0x0502, 0x0506, 1289, 0x050b, 0x050c, 0x050e,
    0x050f, 0x0510,
  ]
  vkcodes = mu68VKCodes
  customLayout: CustomLayout = {
    0x10e: this.createSquare(2, 2, 73),
    0x200: this.createSquare(2, 2, 56),
    0x20e: this.createSquare(2, 2, 54.8),
    0x300: this.createSquare(2, 2, 72),
    0x30e: this.createSquare(2, 2, 80.3),
    0x400: this.createSquare(2, 2, 92),
    0x40d: this.createSquare(2, 2, 59.5),
    0x40c: this.createSquare(2, 2, 60),
    0x500: this.createSquare(2, 2, 47.5),
    0x501: this.createSquare(2, 2, 47.5),
    0x502: this.createSquare(2, 2, 47.5),
    0x506: this.createSquare(2, 2, 220),
    0x509: this.createSquare(2, 2, 47.5),
    0x50b: this.createSquare(2, 2, 47.5),
    0x50c: this.createSquare(2, 2, 47.5),
    0x50e: this.createSquare(2, 2),
  }
  // win按键锁定
  lockWin: boolean = true
  // 回报率
  rate: number[] = [1, 2, 4, 8]
}
